const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;
        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

(function initializeCartAnimation() {
  if (window.innerWidth >= 750) return;

  const popup = document.createElement('div');
  popup.textContent = '追加しました ✓';
  popup.style.cssText = 'position:fixed;bottom:92px;left:42px;transform:translateX(-50%);background:rgba(0,0,0,0.72);color:#fff;font-size:10px;padding:3px 9px;border-radius:20px;pointer-events:none;opacity:0;z-index:99999;white-space:nowrap;';
  document.body.appendChild(popup);

  let cartBtnParent = null;
  let lastAnimationTime = 0;

  function triggerCartAnimation() {
    if (Date.now() - lastAnimationTime < 800) return;
    lastAnimationTime = Date.now();

    if (cartBtnParent) {
      cartBtnParent.animate([
        { transform: 'scale(0.8)'  },
        { transform: 'scale(1.25)' },
        { transform: 'scale(1.0)'  },
        { transform: 'scale(1.15)' },
        { transform: 'scale(0.8)'  }
      ], { duration: 500, easing: 'ease-in-out' });
    }

    popup.animate([
      { opacity: '0', transform: 'translateX(-50%) translateY(6px)'  },
      { opacity: '1', transform: 'translateX(-50%) translateY(0)',    offset: 0.15 },
      { opacity: '1', transform: 'translateX(-50%) translateY(0)',    offset: 0.65 },
      { opacity: '0', transform: 'translateX(-50%) translateY(-4px)' }
    ], { duration: 1800, easing: 'ease-out' });
  }

  const _fetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (url.includes('/cart/add')) triggerCartAnimation();
    return _fetch.apply(this, args);
  };

  const _xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && url.includes('/cart/add')) {
      this.addEventListener('loadstart', triggerCartAnimation);
    }
    return _xhrOpen.apply(this, arguments);
  };

  function updatePositions() {
    let btn = document.getElementById('floatCartButton');
    if (!btn) {
      for (const el of document.querySelectorAll('*')) {
        if (el.shadowRoot) {
          const found = el.shadowRoot.querySelector('#floatCartButton');
          if (found) { btn = found; break; }
        }
      }
    }
    if (!btn) return;
    cartBtnParent = btn.parentElement;
    cartBtnParent.style.transform = 'scale(0.8)';
    cartBtnParent.style.transformOrigin = 'bottom left';
    const r = btn.getBoundingClientRect();
    if (r.width === 0) return;
    const centerX = r.left + r.width / 2;
    popup.style.left   = (centerX + 5) + 'px';
    popup.style.bottom = (window.innerHeight - r.top + 8) + 'px';
  }

  [0, 500, 1000, 2000, 3000].forEach((d) => setTimeout(updatePositions, d));

  let scrollTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(updatePositions, 300);
  }, { passive: true });
})();